import {
    ROUTE_DETAILS_REQUEST,
    ROUTE_DETAILS_SUCCESS,
    ROUTE_DETAILS_FAIL,
   

    STOP_DETAILS_REQUEST,
    STOP_DETAILS_SUCCESS,
    STOP_DETAILS_FAIL,


    ROUTE_NAMES_REQUEST,
    ROUTE_NAMES_SUCCESS,
    ROUTE_NAMES_FAIL,


} from '../constants/gtfsConstants.js'


import { axiosAuthed } from "../auth/createAuthedAxios.ts";

export const getRouteDetails = (routeId) => async (dispatch) => {
   
    try {
        dispatch({
            type: ROUTE_DETAILS_REQUEST
        })

        

        const config = {
            headers: {
                'accept': 'application/json',
            }
        }

        const url = `${process.env.REACT_APP_HOST_IP}gtfs/route_details/${routeId}`

        const { data } = await axiosAuthed.get(

            url,
            config
        )


        dispatch({
            type: ROUTE_DETAILS_SUCCESS,
            payload: data
        })



    } catch (error) {
        dispatch({
            type: ROUTE_DETAILS_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
    }
}


export const getStopDetails = (stopCode) => async (dispatch) => {
   
    try {
        dispatch({
            type: STOP_DETAILS_REQUEST
        })

        

        const config = {
            headers: {
                'accept': 'application/json',
            }
        }

        const url = `${process.env.REACT_APP_HOST_IP}gtfs/stop_details/${stopCode}`

        const { data } = await axiosAuthed.get(

            url,
            config
        )


        dispatch({
            type: STOP_DETAILS_SUCCESS,
            payload: data
        })



    } catch (error) {
        dispatch({
            type: STOP_DETAILS_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
    }
}

export const getRouteNames = () => async (dispatch) => {
  
    try {
        dispatch({
            type: ROUTE_NAMES_REQUEST
        })

        
        const config = {
            headers: {
                'accept': 'application/json',
            }
        }

        // const url = `${process.env.REACT_APP_HOST_IP}gtfs/route_names?debug=true`
        const url = `${process.env.REACT_APP_HOST_IP}gtfs/route_names`

        const { data } = await axiosAuthed.get(

            url,
            config
        )


        dispatch({
            type: ROUTE_NAMES_SUCCESS,
            payload: data
        })



    } catch (error) {
        dispatch({
            type: ROUTE_NAMES_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
    }
}

